/**
 * @module views\sys\db
 */
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";
import TableColumn from "@/components/ghTable/dataTable/tableColumn/tableColumn";

@Component({
  components: {
    TableColumn
  }
})
export default class Database extends GhBase {
  private argsQuery = { db: "portal", keyword: "" };
  private tableId = "";

  private viewColumns(item) {
    this.tableId = item.Id;
  }
}
